import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { SEARCE_COLORS } from '../../theme';

export interface DonutInsightCardShellProps {
  title: string;
  titleAdornment?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Outer shell matching DRI Employee Tier Distribution: bordered Paper, h6 title row.
 */
const DonutInsightCardShell: React.FC<DonutInsightCardShellProps> = ({ title, titleAdornment, children }) => (
  <Paper
    elevation={0}
    sx={{
      p: 3,
      border: `1px solid ${SEARCE_COLORS.neutral_200}`,
      borderRadius: 2,
      backgroundColor: SEARCE_COLORS.white,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 3,
        gap: 2,
        flexWrap: 'wrap',
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 600, color: SEARCE_COLORS.textPrimary, flexShrink: 0 }}>
        {title}
      </Typography>
      {titleAdornment}
    </Box>
    {children}
  </Paper>
);

export default DonutInsightCardShell;
